const auth = {
  login: {
    title: 'Bienvenido',
    subtitle: 'Inicie sesión en su cuenta',
    username: 'Correo electrónico',
    password: 'Contraseña',
    sign_in: 'Iniciar sesión',
    remember_me: 'Recordarme',
    forgot_password: '¿Ha olvidado su contraseña?',
    error: 'Usuario o contrasena incorrectos',
    loading: 'Iniciando sesión…',
  },
  logout: {
    title: 'Cerrar sesión',
    message: '¿Seguro que desea cerrar la sesión?',
    confirm: 'Cerrar sesión',
    cancel: 'Cancelar',
  },
  errors: {
    invalid_credentials: 'Credenciales no válidas',
    session_expired: 'Su sesión ha expirado',
    unauthorized: 'No tiene permisos para acceder a este recurso',
    forbidden: 'Acceso denegado',
    network_error: 'Error de conexión',
  },
  password: {
    change_title: 'Cambiar contraseña',
    current: 'Contraseña actual',
    new_password: 'Nueva contraseña',
    confirm: 'Confirme la nueva contraseña',
    requirements: {
      title: 'La contraseña debe tener:',
      minLength: 'Al menos 8 caracteres',
      uppercase: 'Una letra mayúscula',
      lowercase: 'Una letra minúscula',
      number: 'Un número',
      special: 'Un carácter especial (!@#$%^&*)',
    },
    errors: {
      mismatch: 'Las contraseñas no coinciden',
      weak: 'La contraseña es demasiado débil',
      same: 'La nueva contraseña debe ser diferente de la actual',
    },
    success: 'Contraseña actualizada correctamente',
  },
  roles: {
    admin: 'Superadministrador',
    organization: 'Organización',
    'organization-manager': 'Gestor de organización',
    client: 'Cliente',
    staff: 'Personal',
  },
  session_expiry: {
    title: 'Sesión a punto de expirar',
    message: 'Su sesión expirará pronto. ¿Desea extenderla?',
    extend: 'Extender la sesión',
  },
};

export default auth;
